import { Container } from "@mui/material";
import styles from "./Header.module.scss";
import { Phone } from "../common/Phone";

export const Header = () => {
  return (
    <>
      <Container className={styles.topBar} maxWidth="xl">
        <div className={styles.callSection}>
          <img src="phone.png" alt="Phone icon" />
          <div>
            Potrzebujesz pomocy? Zadzwoń
            <br />
            <Phone className={styles.phone} />
          </div>
        </div>
        <div className={styles.navText}>
          <img src="box.png" alt="Box icon" />
          Dostępność produktów!
        </div>
        <div className={styles.navText}>
          <img src="chart.png" alt="Chart icon" />
          Natychmiastowa realizacja zamówienia
        </div>
        <div className={styles.navText}>
          <img src="gear.png" alt="Gear icon" />
          Fachowość i wieloletnie doświadczenie
        </div>
      </Container>
      <header className={styles.container}>
        <Container>
          <img src="logo.jpg" alt="All-Parts Logo" className={styles.logo} />
        </Container>
      </header>
    </>
  );
};
